<section id="hero" class="hero">
  <div class="hero__overlay"></div>
  <div class="hero__container">
    <div class="hero__content">
<h1 class="hero__title" appScrollAnimate [animationDelay]="150" [threshold]="0.3">Professional installation, sanding and polishing of timber floors
        <br> in Sydney</h1>

      <p class="hero__text" appScrollAnimate [animationDelay]="300" [threshold]="0.3">
        Using modern dust-free equipment and a precise approach, we deliver clean, durable and long-lasting results for both residential and commercial spaces.
      </p>
      <p class="hero__text" appScrollAnimate [animationDelay]="300" [threshold]="0.3">
        Our process:  <strong>Expert floor installation</strong> - <strong>Professional sanding and staining</strong> - <strong>Fine polishing and finishing</strong> - <strong>Full time protection</strong>
      </p>

      <div class="hero__buttons" appScrollAnimate [animationDelay]="450" [threshold]="0.3">
        <button class="hero__button" (click)="navigateToContact()">Get a Quote Now!</button>
        <a href="tel:+61493439216" class="hero__button-phone"><strong>0493 439 216</strong></a>
      </div>

    </div>
  </div>
</section>